import { SeoRenderer } from "../../../../common/helpers/seo";

import loadableComponent from "./loadable";

export default {
    component: loadableComponent,
    renderSeo: (_store, allMessage: any, lang: string) => {
        SeoRenderer({
            title: `Musicators - ${allMessage["memory.slogen"]}`,
            description: allMessage["memory.seo.description"],
            app: "memory",
            allMessage,
            lang,
        });
    },
};
